import { AppText, Button, Column, styled } from '@streem/ui-react';

interface TranscriptionErrorProps {
    onRefresh: () => Promise<void>;
}
export function TranscriptionError({ onRefresh }: TranscriptionErrorProps): JSX.Element {
    return (
        <TranscriptionErrorWrapper>
            <AppText semibold size="medium" headingFontFamily>
                Could not load transcript
            </AppText>
            <AppText>Please refresh to try again</AppText>
            <Button variant="primary" mobile style={{ marginTop: '.625rem' }} onClick={onRefresh}>
                Refresh
            </Button>
        </TranscriptionErrorWrapper>
    );
}

const TranscriptionErrorWrapper = styled(Column)(({ theme }) => ({
    alignItems: 'center',
    padding: '2rem 0',
    border: `0.063rem solid ${theme.colors.grey10}`,
    borderRadius: '0.5rem',
}));
